<template>
    <div class="feedback-wrapper">
        <div class="feedback">
            <div class="head flexBox">
                <span class="flexItem">我想问</span>
                <span class="confirm" @click="submit">提交</span>
            </div>
            <div class="describe" @click="$refs.describeinput.focus()">
                <textarea v-model="describe" placeholder="请描述你的问题..." maxlength="100" spellcheck="false" ref="describeinput"></textarea>
                <div class="total-count">
                    <span class="count" v-text="count"></span><span class="total">/100</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {COMMON} from '../api'

export default {
    name: 'feedback',
    data() {
        return {
            ADAccount: localStorage.ADAccount || 'Unable Get ADAccount'
        }
    },
    mounted() {
        setTimeout(()=>{
            this.$refs.describeinput.focus()
        },500)
    },
    methods: {
        submit() {

            this.$refs.describeinput.blur()

            if (this.describe.length == 0) {
                this.$store.commit('SetAndCallToast', '请写点什么吧')
                return
            }

            COMMON.AddFeedback({
                Content: this.describe,
                ADAccount: this.ADAccount
            }).then((res) => {

                if (res.Code == 200) {
                    this.$store.commit('SetAndCallToast', '提交成功,我们会尽快联系相关人员解答～')
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 2000)
                } else {
                    this.$store.commit('SetAndCallToast', '提交失败')
                }
            })
        },
    },
    computed: {
        count() {
            return this.describe.length
        },
        describe(){
            return sessionStorage.nio_question || ''
        }
    },
}
</script>
<style lang="scss" type="text/scss" scoped>
    .feedback-wrapper {
        .feedback {
            padding: j(50) j(50) 0;
            color: #363C54;
            font-size: j(52);
            .head {
                position: relative;
                @extend %bb1;
                padding-bottom: j(50);

                .confirm {
                    color: #00bcbc;
                    font-size: j(36);
                    transition: all .3s;

                    &.disable {
                        pointer-events: none;
                        color: #cccccc;
                    }
                }
            }

            .describe {
                position: relative;
                @extend %bb1;
                width: 100%;
                height: j(340);

                textarea {
                    width: 100%;
                    height: j(310);
                    padding-top: j(30);
                    font-size: j(32);
                    line-height: j(45);
                    caret-color:#00bebe;
                    color: #363C54;
                    resize: none;

                    &::-webkit-input-placeholder {
                        color: #9B9DA9;
                        font-size: j(32);
                        padding-left: j(10);
                        padding-top: 1px;
                    }
                }

                .total-count {
                    position: absolute;
                    bottom: j(30);
                    right: 0;
                    font-size: j(32);
                    color: #cccccc;
                }
            }

            /* .submit {
                position: fixed;
                bottom: j(24);
                left: j(50);
                right: j(50);
                height: j(90);
                line-height: j(90);
                &.disable {
                    pointer-events: none;
                }
                span {
                    font-size: j(36);
                    width: 100%;
                    text-align: center;
                    letter-spacing: 2px;
                    color: #ffffff;
                    background-color: #00bebe;
                    border-radius: j(45);
                    transition: all .5s;
                    &.disable {
                        pointer-events: none;
                        background-color: #d7d7d7;
                    }
                }
            } */
        }

        .confirm-toast {
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;

            background: rgba(0, 15, 23, .5);

            .toast-wrap {
                margin: 0 j(75);
                font-size: j(36);
                // color: #333333;
                color: #363C54;
                background: #ffffff;
                width: 100%;
                border-radius: j(12);
                text-align: center;

                .toast-text {
                    padding: j(88) j(75) j(80);
                    line-height: j(50);
                    // border-bottom: 1px solid #f5f5f5;
                    border-bottom: 1px solid #f0f1f2;
                }

                .toast-btn {
                    font-size: 0;
                    height: j(90);

                    span {
                        height: j(90);
                        line-height: j(90);
                        width: 50%;
                        color: #00bcbc;
                        font-size: j(36);
                        display: inline-block;

                        &.cancel {
                            // border-left: 1px solid #f5f5f5;
                            border-left: 1px solid #f0f1f2;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/feedback.vue